import {  Injectable } from '@angular/core';
import { BehaviorSubject, Subject  } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IframeService {
   private iframeUrlSubject = new BehaviorSubject<string | null>(null);
  iframeUrl$ = this.iframeUrlSubject.asObservable();

   private iframeCommandSubject = new Subject<{ type: string; tabName?: string }>();
   iframeCommand$ = this.iframeCommandSubject.asObservable();
   private popupOpenedSubject = new BehaviorSubject<string | null>(null);
   popupOpened$ = this.popupOpenedSubject.asObservable(); // <-- must be declared here

  setUrl(url: string | null) {
    this.iframeUrlSubject.next(url);
  }

  sendCommand(command: { type: string; tabName?: string }) {
    this.iframeCommandSubject.next(command);
  }

  public isIframeAlive(): boolean {
    const iframe = document.getElementById('myIframe') as HTMLIFrameElement;
    return !!iframe && !!iframe.contentWindow;
  }

  public setPopupOpened(popupName: string) {
    this.popupOpenedSubject.next(popupName);
  }
}
